import { BasicsClass } from '@/common/BasicsClass';

export class DeviceAPI extends BasicsClass {
    public apiUrls: any = new Map([
        ['getDeviceTableList', {
            url: '/admin/device/lists',
            name: 'list',
            label: '列表'
        }],
        ['addDevice', {
            url: '/admin/device/add',
            name: 'add',
            label: '添加设备'
        }],
        ['updateDevice', {
            url: '/admin/device/update',
            name: 'update',
            label: '修改设备'
        }],
        ['unbindDevice', {
            url: '/admin/device/unbind',
            name: 'unbind',
            label: '解绑设备'
        }],
    ])


    // // 设备列表
    public getDeviceTableList(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
      const apiUrls = this.apiUrls

      const url = apiUrls.get('getDeviceTableList').url

      this.BasicPost(url, {
          ...params
      }, false, false, false, successCb, failCb, showLoading)
    }

    public addDevice(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('addDevice').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public updateDevice(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('updateDevice').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }

    public unbindDevice(params: any, successCb: Function, failCb: Function, showLoading: boolean = false) {
        const apiUrls = this.apiUrls

        const url = apiUrls.get('unbindDevice').url

        this.BasicPost(url, {
            ...params
        }, false, false, false, successCb, failCb, showLoading)
    }


}